import React from "react";

export default function ChoiceChips({label, choices, value, onChange}) {
  function handleClick(val, optionEnabled = true) {
    if (!optionEnabled) return;
    onChange(val === value ? '' : val)
  }

  return <div className='choice-chips'>
    <div className='choice-chips-label'>
      <label>{label}</label>
    </div>
    <div className='choice-chips-items'>
      {choices.map(option => {
        const isOptionDisabled = (option.enabled !== undefined ? !option.enabled : false);
        return (
          <button
            disabled={isOptionDisabled}
            key={option.value}
            className={parseInt(value) === parseInt(option.value) ? 'choice-chips-item active' : 'choice-chips-item'}
            onClick={evt => handleClick(option.value, option.enabled !== undefined ? option.enabled : true)}
          >
            {option.name}
          </button>
        );
      })}
    </div>
  </div>
}
